import { useCallback, useEffect, useRef, useState } from "react"
import { ErrorCard, LoadingCard, MainContainer, VirtualizeAutoComplete } from "../../components"
import {
    Button, Autocomplete, AutocompleteItem, Checkbox, Input, Select, SelectItem, TableColumn, Table
    , TableCell, TableBody, TableHeader, TableRow,
    Drawer, DrawerContent, DrawerHeader, DrawerBody, DrawerFooter, useDisclosure,
} from "@nextui-org/react"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { apiRoute, ENUM_INPUT_TYPE, linksUrl } from "../../constants/enum"
import { isMobile } from "react-device-detect"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks"
import { useSelector } from "react-redux"
import { faArchway, faArrowPointer, faAsterisk, faCancel, faPlus, faSave } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"

const CreateBeamCardEntry = () => {
    const { compCode } = useSelector((state) => state.company)
    const { isNewEntry, detailParams } = useSelector((state) => state.beamCard)
    const { user } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const [isBeamIssue, setIsBeamIssue] = useState(1)

    const { isOpen, onOpen, onOpenChange } = useDisclosure();
    const ENUM_BEAM_POSITION = [
        { name: "TOP", value: 1 },
        { name: "CENTER", value: 2 },
        { name: "BOTTOM", value: 3 }
    ]

    const { data: masterData = [] } = useFetchWithBody({
        url: apiRoute.beamTransaction.beamCardEntry.entryMasterData,
        queryKey: "getMasterData",
        inputData: {
            compcode: compCode.join(",")
        }
    })


    const onSuccessTasks = (data) => {

        navigate(linksUrl.beamTransaction.beamCardEntry.beamCardEntryMatser);
    }
    const { isError, isPending, mutate: funAddUpdate } = usePost({
        url: apiRoute.beamTransaction.beamCardEntry.add_update,
        queryKey: "funAddUpdateBeamCard",
        onSuccessTasks
    })

    const { isError: isErrorDetail, data: detail = [], mutate: funGetDetail } = usePost({
        url: apiRoute.beamTransaction.beamCardEntry.fetchEntryDetail,
        queryKey: "fetchProductionDetail",
    });

    useEffect(() => {
        if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
            const { comp_code, id_no } = detailParams
            funGetDetail({
                data: {
                    comp_code: comp_code,
                    id_no: id_no,
                }
            })
        }
    }, [])


    const formField = {
        beamCard: {
            idNo: "idNo",
            proUnitId: "proUnitId",
            proUnitName: "proUnitName",
            beamNo: "beamNo",
            productionDate: "ProductionDate",
            warMcNo: "warMcNo",
            warCode: "warCode",
            lotNo: "lotNo",
            denier: "denier",
            ends: "ends",
            taka: "taka",
            meter: "meter",
            weight: "weight",
            yarnItemCode: "yarnItemCode",
            yarnItemName: "yarnItemName",
        },
        beamIssue: {

            beamSrNo: "beamSrNo",
            loadDate: "loadDate",
            weavUnitId: "weavUnitId",
            weavUnitName: "weavUnitName",
            loomMcNo: "loomMcNo",
            position: "position",
            fabItemCode: "fabItemCode",
            fabItemName: "fabItemName",
            apxShorPer: "apxShorPer",
            shrtMeter: "shrtMeter",
            position: "position",
            avgMeter: "avgMeter",
            apxFinishDate: "apxFinishDate",
            finishDate: "finishDate"
        }


    }

    const emptyFormFieldBCard = Object.keys(formField.beamCard).reduce((acc, key) => {
        if (key == formField.beamCard.productionDate)
            acc[key] = new Date()
        if (key == formField.beamCard.idNo)
            acc[key] = 0
        else acc[key] = ""
        return acc
    }, {})

    const emptyFormFieldBIssue = Object.keys(formField.beamIssue).reduce((acc, key) => {
        if (key == formField.beamIssue.loadDate)
            acc[key] = new Date()
        else if (key == formField.beamIssue.finishDate || key == formField.beamIssue.apxFinishDate)
            acc[key] = null
        else acc[key] = ""
        return acc
    }, {})

    const [formBeamCard, setFormBeamCard] = useState({
        ...emptyFormFieldBCard
    })
    const [formBeamIssue, setFormBeamIssue] = useState({
        ...emptyFormFieldBIssue
    })


    const inputBoxesBeamCard = {

        Row1: [
            {
                id: formField.beamCard.proUnitId,
                name: formField.beamCard.proUnitId,
                placeholder: "Beam Production Unit",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.unitMaster ? masterData?.unitMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: true,
            },
            {
                name: formField.beamCard.beamNo,
                placeholder: "Beam No",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
        ],
        Row2: [

            {
                name: formField.beamCard.productionDate,
                placeholder: "Production Date",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                id: formField.beamCard.yarnItemCode,
                name: formField.beamCard.yarnItemCode,
                placeholder: "Yarn Item ",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.yarnMaster ? masterData?.yarnMaster : [],
                itemkey: "Item_Code",
                itemvalue: "Item_Desc",
                isrequired: true,
            },

        ],
        Row3: [
            {
                name: formField.beamCard.warMcNo,
                placeholder: "Warping Mac.No",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                id: formField.beamCard.warCode,
                name: formField.beamCard.warCode,
                placeholder: "Warper Name ",
                type: ENUM_INPUT_TYPE.select,
                size: "sm",
                label: "",
                data: masterData && masterData?.warperMaster ? masterData?.warperMaster : [],
                itemkey: "EmpCode",
                itemvalue: "EmpName",
                isrequired: false,
            },


        ],
        Row4: [
            {
                name: formField.beamCard.lotNo,
                placeholder: "Lot No",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                name: formField.beamCard.denier,
                placeholder: "Denier",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                name: formField.beamCard.ends,
                placeholder: "Ends",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: true,
            }
        ],
        Row5: [
            {
                name: formField.beamCard.taka,
                placeholder: "Taka",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                name: formField.beamCard.meter,
                placeholder: "Meter",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                name: formField.beamCard.weight,
                placeholder: "Weight",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: true,
            }
        ],


    }

    const inputBoxesBeamIssue = {

        Row1: [
            {
                id: formField.beamIssue.weavUnitId,
                name: formField.beamIssue.weavUnitId,
                placeholder: "Weave Unit",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.unitMaster ? masterData?.unitMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: true,
            },
            {
                name: formField.beamIssue.beamSrNo,
                placeholder: "Beam SrNo",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
        ],
        Row2: [

            {
                name: formField.beamIssue.loadDate,
                placeholder: "Load Date",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                id: formField.beamIssue.fabItemCode,
                name: formField.beamIssue.fabItemCode,
                placeholder: "Fabric Item ",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.grayMaster ? masterData?.grayMaster : [],
                itemkey: "Item_Code",
                itemvalue: "Item_Desc",
                isrequired: true,
            },

        ],
        Row3: [
            {
                name: formField.beamIssue.loomMcNo,
                placeholder: "Looms Mac.No",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.beamIssue.position,
                name: formField.beamIssue.position,
                placeholder: "Position ",
                type: ENUM_INPUT_TYPE.select,
                size: "sm",
                label: "",
                data: ENUM_BEAM_POSITION,
                itemkey: "value",
                itemvalue: "name",
                isrequired: false,
            },


        ],
        Row4: [
            {
                name: formField.beamIssue.apxShorPer,
                placeholder: "Approx Shortage %",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                name: formField.beamIssue.shrtMeter,
                placeholder: "Shrt.Mtr.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },

        ],
        Row5: [
            {
                name: formField.beamIssue.avgMeter,
                placeholder: "Daily Avg.Meter",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                name: formField.beamIssue.apxFinishDate,
                placeholder: "Appx.Finish Date",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: false,
            },

        ],
        Row6: [
            {
                name: formField.beamIssue.apxFinishDate,
                placeholder: "Finish Date",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: false,
            },


        ],


    }

    const funCalWeight = (denier, ends, mtr) => {
        if (denier != "" && ends != "" && mtr != "") {
            let val = (denier * ends * mtr) / 9000000
            return val.toFixed(2)
        }
        else
            return 0
    }

    const handleChangeBeamCard = (e) => {
        const { name, value } = e.target

        let t_denier = formBeamCard[formField.beamCard.denier] ?? 0
        let t_ends = formBeamCard[formField.beamCard.ends] ?? 0
        let t_meter = formBeamCard[formField.beamCard.meter] ?? 0

        if (name == formField.beamCard.denier)
            t_denier = value
        else if (name == formField.beamCard.ends)
            t_ends = value
        else if (name == formField.beamCard.meter)
            t_meter = value

        const t_weight = funCalWeight(t_denier, t_ends, t_meter)

        setFormBeamCard({ ...formBeamCard, [name]: value, [formField.beamCard.weight]: t_weight })
    }
    const handleChangeBeamIssue = (e) => {
        const { name, value } = e.target

        setFormBeamIssue({ ...formBeamIssue, [name]: value })
    }
    const handleAutoCompleteChange = (value, name) => {
        if (name == formField.beamCard.proUnitId || name == formField.beamCard.yarnItemCode) {
            setFormBeamCard({
                ...formBeamCard,
                // [id]: data.selectedKey,
                [name]: value,
            })
        }
        else if (name == formField.beamIssue.fabItemCode || name == formField.beamIssue.weavUnitId) {
            setFormBeamIssue({
                ...formBeamCard,
                // [id]: data.selectedKey,
                [name]: value,
            })
        }
    }
    const handleVirtualizeChanged = (data) => {
        const { id, name } = data
        if (id == formField.beamCard.proUnitId || id == formField.beamCard.yarnItemCode) {
            setFormBeamCard({
                ...formBeamCard,
                [id]: data.selectedKey,
                [name]: data.selectedValue,
            })
        }
        else if (id == formField.beamIssue.fabItemCode || id == formField.beamIssue.weavUnitId) {
            setFormBeamIssue({
                ...formBeamCard,
                [id]: data.selectedKey,
                [name]: data.selectedValue,
            })
        }

    }


    const [errors, setErrors] = useState({})

    const validateForm = () => {
        const newErrors = {}

        if (formBeamCard[formField.beamCard.beamNo].trim() == "") {
            newErrors[formField.beamCard.beamNo] = "Beam No is required"
        }

        if (formBeamCard[formField.beamCard.proUnitId] == "" || formBeamCard[formField.beamCard.proUnitId] == "0") {
            newErrors[formField.beamCard.proUnitId] = "Production Unit is required"
        }

        if (formBeamCard[formField.beamCard.yarnItemCode] == "" || formBeamCard[formField.beamCard.yarnItemCode] == "0") {
            newErrors[formField.beamCard.yarnItemCode] = "Yarn Item is required"
        }

        if (formBeamCard[formField.beamCard.warMcNo] == "" || formBeamCard[formField.beamCard.warMcNo] == "0") {
            newErrors[formField.beamCard.warMcNo] = "Machine No is required"
        }

        if (formBeamCard[formField.beamCard.lotNo].trim() == "" || formBeamCard[formField.beamCard.lotNo] == "0") {
            newErrors[formField.beamCard.lotNo] = "Lot No is required"
        }

        if (formBeamCard[formField.beamCard.denier] == "" || formBeamCard[formField.beamCard.denier] == "0") {
            newErrors[formField.beamCard.denier] = "Denier is required"
        }

        if (formBeamCard[formField.beamCard.ends] == "" || formBeamCard[formField.beamCard.ends] == "0") {
            newErrors[formField.beamCard.ends] = "Ends is required"
        }

        if (formBeamCard[formField.beamCard.taka] == "" || formBeamCard[formField.beamCard.taka] == "0") {
            newErrors[formField.beamCard.taka] = "Taka is required"
        }

        if (formBeamCard[formField.beamCard.meter] == "" || formBeamCard[formField.beamCard.meter] == "0") {
            newErrors[formField.beamCard.meter] = "Meter is required"
        }

        if (formBeamCard[formField.beamCard.weight] == "" || formBeamCard[formField.beamCard.weight] == "0") {
            newErrors[formField.beamCard.weight] = "Weight No is required"
        }

        setErrors(newErrors)

        // Return true if there are no errors
        return Object.keys(newErrors).length === 0
    }

    useEffect(() => {
        validateForm();
    }, [formBeamCard])

    const handleSubmit = (e) => {
        e.preventDefault()


        const validate_form = validateForm()
        if (validate_form) {
            funAddUpdate({
                data: {
                    compcode: compCode.join(","),
                    beamRecData: formBeamCard,
                    beamIsuData: isBeamIssue ? formBeamIssue : [],
                    login_userid: user.username,
                    rec_status: !isNewEntry ? 1 : 2
                }
            })
        }

    }

    useEffect(() => {
        if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
            if (detail && detail.length > 0) {
                setFormBeamCard({
                    ...formBeamCard,
                    [formField.beamCard.idNo]: detail[0]?.idno,
                    [formField.beamCard.proUnitId]: detail[0]?.lac_id,
                    [formField.beamCard.proUnitName]: detail[0]?.unit_name,
                    [formField.beamCard.beamNo]: detail[0]?.beam_no,
                    [formField.beamCard.productionDate]: detail[0]?.i_date,
                    [formField.beamCard.yarnItemCode]: detail[0]?.item_code,
                    [formField.beamCard.yarnItemName]: detail[0]?.item_name,
                    [formField.beamCard.warMcNo]: detail[0]?.mc_no,
                    [formField.beamCard.warCode]: detail[0]?.w_empcode,
                    [formField.beamCard.lotNo]: detail[0]?.lot_no,
                    [formField.beamCard.taka]: detail[0]?.taka,
                    [formField.beamCard.denier]: detail[0]?.denier,
                    [formField.beamCard.ends]: detail[0]?.ends,
                    [formField.beamCard.meter]: detail[0]?.meter,
                    [formField.beamCard.weight]: detail[0]?.weight,

                })
            }
        }

    }, [detail])
    const handleClickPrev = () => {
        navigate(linksUrl.beamTransaction.beamCardEntry.beamCardEntryMatser)
    }
    const handleBeamDetail = () => {

    }

    if (isPending) {
        return <LoadingCard />;
    }
    if (isError || isErrorDetail) {
        return <ErrorCard />;
    }

    return (
        <div className="border-2 ">
            {/* <div className="absolute right-0 h-16 w-16 bg-purple-400 text-white ">Beam Card</div> */}
            <MainContainer
                pageName="Beam Transaction"
                breadcrumbs={["Beam Card Entry"]}
                prevPage={{
                    show: true,
                    onClick: handleClickPrev,
                }}
            >
                <div shadow="sm" className="mb-3 w-full">



                    <form onSubmit={handleSubmit} autoComplete='off'>

                        <div className=" font-semibold text-xs flex justify-between  text-sky-700  mb-5 p-1 border-l-2 border-l-gray-600 border-b-1 border-b-sky-700">
                            <div>
                                <FontAwesomeIcon
                                    className="pl-2 text-rose-600 pr-3"
                                    icon={faArrowPointer}
                                ></FontAwesomeIcon>
                                BEAM PRODUCTION
                            </div>
                            <div className="absolute -top-1  right-0">


                            </div>
                        </div>
                        <div className="">
                            <div >
                                {
                                    Object.keys(inputBoxesBeamCard).map((key, ind) => (
                                        <div key={key + ind}>
                                            <div className={` ${isMobile ? 'flex-wrap' : ''}   flex gap-4 align-top items-baseline mb-2 `}>
                                                {
                                                    inputBoxesBeamCard[key].map((item, indx) =>
                                                        item.type == ENUM_INPUT_TYPE.select ? (
                                                            <Select
                                                                name={item?.name}
                                                                placeholder="--select--"
                                                                label={item?.placeholder}
                                                                isInvalid={errors[item.name]}
                                                                errorMessage={errors[item.name]}
                                                                labelPlacement="outside"
                                                                selectionMode="single"
                                                                isRequired={item.isrequired}
                                                                value={formBeamCard[item.name]}
                                                                items={item.data ? item.data : []}
                                                                onChange={handleChangeBeamCard}
                                                                classNames={{
                                                                    label: "text-xs text-black font-bold",
                                                                }}
                                                                selectedKeys={[String(formBeamCard[item.name])]}
                                                            >
                                                                {(list) => {
                                                                    return (
                                                                        <SelectItem key={list[item.itemkey]}>
                                                                            {list[item.itemvalue]}
                                                                        </SelectItem>
                                                                    );
                                                                }}
                                                            </Select>
                                                        ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                            <Autocomplete
                                                                size="md"
                                                                name={item.name}
                                                                isInvalid={errors[item.name]}
                                                                errorMessage={errors[item.name]}
                                                                label={item?.placeholder}
                                                                eventResizeFeature={true}
                                                                selectionMode="single"
                                                                showScrollIndicators={true}
                                                                labelPlacement={"outside"}
                                                                placeholder={item.placeholder}
                                                                isRequired={item.isrequired}
                                                                className="max-w-23"
                                                                classNames={{
                                                                    label: "text-xs text-black font-bold",
                                                                }}
                                                                isClearable={false}
                                                                isVirtualized
                                                                defaultItems={
                                                                    item.data ? item.data : []
                                                                }
                                                                onSelectionChange={(e) =>
                                                                    handleAutoCompleteChange(e, item.name)
                                                                }
                                                                color={item.name == formField.beamCard.proUnitId ? "danger" :
                                                                    item.name == formField.beamCard.yarnItemCode ? "primary" :
                                                                        ""}
                                                                //onChange={handleFormSelectionChange}
                                                                selectedKey={formBeamCard[item.name]}
                                                            >
                                                                {(list) => (
                                                                    <AutocompleteItem

                                                                        key={list[item.itemkey]}
                                                                    >
                                                                        {list[item.itemvalue]}
                                                                    </AutocompleteItem>
                                                                )}
                                                            </Autocomplete>
                                                            // <VirtualizeAutoComplete
                                                            //     id={item.id}
                                                            //     name={item.name}
                                                            //     placeholder={item.placeholder}
                                                            //     required={item.isrequired}
                                                            //     itemKey={item.itemkey}
                                                            //     itemValue={item.itemvalue}
                                                            //     labelPlacement={"outside"}
                                                            //     items={item.data ? item.data : []}
                                                            //     handleVirtualizeChanged={handleVirtualizeChanged}
                                                            //     selectedValue={formBeamCard[item.name]}
                                                            //     classNames={{
                                                            //         label: "text-xs text-black font-bold",
                                                            //     }}
                                                            //     variant={"flat"}
                                                            //     size={"md"}
                                                            //     fixheight={"0"}
                                                            //     readonly={false}
                                                            //     color={item.id == formField.beamCard.proUnitId ? "danger" :
                                                            //         item.id == formField.beamCard.yarnItemCode ? "primary" :
                                                            //             ""}
                                                            //     //isInvalid={errors?.challanNo}
                                                            //     errorMessage={errors[item.id]}


                                                            // />

                                                        ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                            <div className=" w-full flex items-center">
                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                    <DatePicker
                                                                        label={item.placeholder}
                                                                        views={["day", "month", "year"]}
                                                                        format="DD/MM/YYYY"
                                                                        value={
                                                                            formBeamCard[item.name]
                                                                                ? dayjs(formBeamCard[item.name])
                                                                                : formBeamCard[item.name]
                                                                        }
                                                                        onChange={(newValue) => {
                                                                            setFormBeamCard((prev) => {
                                                                                return {
                                                                                    ...prev,
                                                                                    [item.name]:
                                                                                        dayjs(newValue).format("YYYY-MM-DD"),

                                                                                };
                                                                            });
                                                                        }}
                                                                        //isRequired={item.required}
                                                                        className="w-full "
                                                                        slotProps={{
                                                                            textField: { size: "small", required: true },
                                                                        }}
                                                                    />
                                                                </LocalizationProvider>
                                                            </div>
                                                        ) : (
                                                            <Input
                                                                type={item.type}
                                                                name={item.name}
                                                                id={item.name}
                                                                isInvalid={errors[item.name]}
                                                                errorMessage={errors[item.name]}
                                                                //aria-label={item.placeholder}
                                                                placeholder={item.placeholder}
                                                                label={item.placeholder}
                                                                labelPlacement="outside"
                                                                isRequired={item.isrequired}
                                                                value={formBeamCard[item.name]}
                                                                variant="bordered"

                                                                onChange={(e) => handleChangeBeamCard(e)}
                                                                size={"md"}
                                                                classNames={{
                                                                    label: "text-xs text-black font-bold",
                                                                }}
                                                            ></Input>
                                                        )
                                                    )
                                                }
                                            </div>

                                        </div>

                                    ))
                                }
                            </div>
                            {/* <div className="p-5 border-1 border-sky-300 w-full">
                                <h4 className="p-5 font-semibold">Beam Detail</h4>
                                <Table
                                    classNames={{
                                        table:["border-1"],
                                        tr: ["hover:bg-lime-50", "hover:text-rose-500",
                                            "border-b-1 ", "border-gray-100", "text-xs", "font-semibold", "cursor-pointer"],
                                        th: ["bg-blue-700 text-white "],
                                        td: ["text-center"]
                                    }}
                                >

                                    <TableHeader>
                                        <TableColumn>Sr. No</TableColumn>
                                        <TableColumn>Taka No</TableColumn>
                                        <TableColumn>Meter</TableColumn>
                                        <TableColumn>Weight</TableColumn>
                                    </TableHeader>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>
                                                1
                                            </TableCell>
                                            <TableCell className="">
                                                1
                                            </TableCell>
                                            <TableCell>
                                                120
                                            </TableCell>
                                            <TableCell>

                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                1
                                            </TableCell>
                                            <TableCell className="">
                                                1
                                            </TableCell>
                                            <TableCell>
                                                120
                                            </TableCell>
                                            <TableCell>

                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                1
                                            </TableCell>
                                            <TableCell className="">
                                                1
                                            </TableCell>
                                            <TableCell>
                                                120
                                            </TableCell>
                                            <TableCell>

                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </div> */}
                        </div>
                        <div>
                            <Button color="danger" onPress={onOpen} variant="shadow" size="sm" > BEAM Detail</Button>

                            <Drawer isOpen={isOpen} onOpenChange={onOpenChange}>
                                <DrawerContent>
                                    {(onClose) => (
                                        <>
                                            <DrawerHeader className="flex flex-col gap-1">Beam Detail</DrawerHeader>
                                            <DrawerBody>
                                                <Table
                                                    classNames={{
                                                        table: ["border-1"],
                                                        tr: ["hover:bg-lime-50", "hover:text-rose-500",
                                                            "border-b-1 ", "border-gray-100", "text-xs", "font-semibold", "cursor-pointer"],
                                                        th: ["bg-blue-700 text-white "],
                                                        td: ["text-center"]
                                                    }}
                                                >

                                                    <TableHeader>
                                                        <TableColumn>Sr. No</TableColumn>
                                                        <TableColumn>Taka No</TableColumn>
                                                        <TableColumn>Meter</TableColumn>
                                                        <TableColumn>Weight</TableColumn>
                                                    </TableHeader>
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell>
                                                                1
                                                            </TableCell>
                                                            <TableCell className="">
                                                                1
                                                            </TableCell>
                                                            <TableCell>
                                                                120
                                                            </TableCell>
                                                            <TableCell>

                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell>
                                                                1
                                                            </TableCell>
                                                            <TableCell className="">
                                                                1
                                                            </TableCell>
                                                            <TableCell>
                                                                120
                                                            </TableCell>
                                                            <TableCell>

                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell>
                                                                1
                                                            </TableCell>
                                                            <TableCell className="">
                                                                1
                                                            </TableCell>
                                                            <TableCell>
                                                                120
                                                            </TableCell>
                                                            <TableCell>

                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                    </Table>
                                            </DrawerBody>
                                            <DrawerFooter>
                                                {/* <Button color="danger" variant="light" onPress={onClose}>
                  Close
                </Button>
                <Button color="primary" onPress={onClose}>
                  Action
                </Button> */}
                                            </DrawerFooter>
                                        </>
                                    )}
                                </DrawerContent>
                            </Drawer>
                        </div>
                        {/* //beam Isuue form start */}
                        <div className="mt-5 ">
                            <div className=" font-semibold text-xs  text-sky-700  mb-5 p-1 border-l-2 border-l-gray-600 border-b-1 border-b-sky-700">
                                <Checkbox isSelected={isBeamIssue} onValueChange={setIsBeamIssue} size="md" color="primary" className="ml-3 font-xs">
                                    <FontAwesomeIcon
                                        className="pl-1 text-rose-600 pr-1"
                                        icon={faArrowPointer}
                                    ></FontAwesomeIcon>
                                </Checkbox>
                                <span className="text-xs" >   BEAM ISSUE</span>
                            </div>
                            {
                                Object.keys(inputBoxesBeamIssue).map((key, ind) => (
                                    <div key={key + ind}>
                                        <div className={` ${isMobile ? 'flex-wrap' : ''}   flex gap-4 align-top items-first mb-2 `}>
                                            {
                                                inputBoxesBeamIssue[key].map((item, indx) =>
                                                    item.type == ENUM_INPUT_TYPE.select ? (
                                                        <Select
                                                            name={item?.name}
                                                            placeholder="--select--"
                                                            label={item?.placeholder}
                                                            isInvalid={errors[item.name]}
                                                            errorMessage={errors[item.name]}
                                                            labelPlacement="outside"
                                                            selectionMode="single"
                                                            isRequired={item.isrequired}
                                                            value={formBeamIssue[item.name]}
                                                            items={item.data ? item.data : []}
                                                            onChange={handleChangeBeamIssue}
                                                            classNames={{
                                                                label: "text-xs text-black font-bold",
                                                            }}
                                                            selectedKeys={[String(formBeamIssue[item.name])]}
                                                        >
                                                            {(list) => {
                                                                return (
                                                                    <SelectItem key={list[item.itemkey]}>
                                                                        {list[item.itemvalue]}
                                                                    </SelectItem>
                                                                );
                                                            }}
                                                        </Select>
                                                    ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                        <Autocomplete
                                                            size="md"
                                                            name={item.name}
                                                            isInvalid={errors[item.name]}
                                                            errorMessage={errors[item.name]}
                                                            label={item?.placeholder}
                                                            eventResizeFeature={true}
                                                            selectionMode="single"
                                                            showScrollIndicators={true}
                                                            labelPlacement={"outside"}
                                                            placeholder={item.placeholder}
                                                            isRequired={item.isrequired}
                                                            className="max-w-23"
                                                            classNames={{
                                                                label: "text-xs text-black font-bold",
                                                            }}
                                                            isClearable={false}
                                                            isVirtualized
                                                            defaultItems={
                                                                item.data ? item.data : []
                                                            }
                                                            onSelectionChange={(e) =>
                                                                handleAutoCompleteChange(e, item.name)
                                                            }
                                                            color={item.name == formField.beamIssue.weavUnitId ? "danger" :
                                                                item.name == formField.beamIssue.fabItemCode ? "primary" :
                                                                    ""}
                                                            selectedKey={formBeamIssue[item.name]}
                                                        >
                                                            {(list) => (
                                                                <AutocompleteItem

                                                                    key={list[item.itemkey]}
                                                                >
                                                                    {list[item.itemvalue]}
                                                                </AutocompleteItem>
                                                            )}
                                                        </Autocomplete>
                                                        // <VirtualizeAutoComplete
                                                        //     id={item.id}
                                                        //     name={item.name}
                                                        //     placeholder={item.placeholder}
                                                        //     required={item.isrequired}
                                                        //     itemKey={item.itemkey}
                                                        //     itemValue={item.itemvalue}
                                                        //     labelPlacement={"outside"}
                                                        //     items={item.data ? item.data : []}
                                                        //     handleVirtualizeChanged={handleVirtualizeChanged}
                                                        //     selectedValue={formBeamIssue[item.name]}
                                                        //     classNames={{
                                                        //         label: "text-xs text-black font-bold",
                                                        //     }}
                                                        //     variant={"flat"}
                                                        //     size={"md"}
                                                        //     fixheight={"0"}
                                                        //     readonly={false}
                                                        //     color={item.id == formField.beamIssue.weavUnitId ? "danger" :
                                                        //         item.id == formField.beamIssue.fabItemCode ? "primary" :
                                                        //             ""}
                                                        //     //isInvalid={errors?.challanNo}
                                                        //     errorMessage={errors[item.id]}


                                                        // />

                                                    ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                        <div className=" w-full flex items-center">
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <DatePicker
                                                                    label={item.placeholder}
                                                                    views={["day", "month", "year"]}
                                                                    format="DD/MM/YYYY"
                                                                    value={
                                                                        formBeamIssue[item.name]
                                                                            ? dayjs(formBeamIssue[item.name])
                                                                            : formBeamIssue[item.name]
                                                                    }
                                                                    onChange={(newValue) => {
                                                                        setFormBeamIssue((prev) => {
                                                                            return {
                                                                                ...prev,
                                                                                [item.name]:
                                                                                    dayjs(newValue).format("YYYY-MM-DD"),

                                                                            };
                                                                        });
                                                                    }}
                                                                    //isRequired={item.required}
                                                                    className="w-full "
                                                                    slotProps={{
                                                                        textField: { size: "small", required: true },
                                                                    }}
                                                                />
                                                            </LocalizationProvider>
                                                        </div>
                                                    ) : (
                                                        <Input
                                                            type={item.type}
                                                            name={item.name}
                                                            id={item.name}
                                                            isInvalid={errors[item.name]}
                                                            errorMessage={errors[item.name]}
                                                            //aria-label={item.placeholder}
                                                            placeholder={item.placeholder}
                                                            label={item.placeholder}
                                                            labelPlacement="outside"
                                                            isRequired={item.isrequired}
                                                            value={formBeamIssue[item.name]}
                                                            variant="bordered"
                                                            disabled={false} onChange={(e) => handleChangeBeamIssue(e)}
                                                            size={"md"}
                                                            classNames={{
                                                                label: "text-xs text-black font-bold",
                                                            }}
                                                        ></Input>
                                                    )
                                                )
                                            }
                                        </div>

                                    </div>

                                ))
                            }
                        </div>
                        {/* end beam issue */}
                        <div className="justify-center flex gap-5">
                            <Button
                                color="primary"
                                type="submit"
                                size="md"
                                variant="shadow"
                                tabIndex={-1}
                                startContent={<FontAwesomeIcon icon={faSave} />}
                            >
                                Submit
                            </Button>
                            <Button
                                color="danger"
                                variant="shadow"
                                size="md"
                                tabIndex={-1}
                                onClick={handleClickPrev}
                                startContent={<FontAwesomeIcon icon={faCancel} />}
                            >
                                Cancel
                            </Button>
                        </div>
                    </form>
                </div>
            </MainContainer>
        </div>
    )

}
export default CreateBeamCardEntry